<template>
    <div>
        <nsw-menu
            :isShowDesktopMenu="false"
        ></nsw-menu>
        <div class="content-wrapper general">
            <h3 class="title-head">{{ lang($t('Disclaimer'))}}</h3>
            <div class="content-box">

                <div class="terms-para">
                    <ul>
                        <li><p>{{ lang($t("You acknowledge and agree that if you decide to browse or utilize the services provided by the Editora Kai Yuen de Macau, you do it entirely at your own risk . Editora Kai Yuen de Macau will not be liable for any loss or damage arising from or in connection with or otherwise associated with browsing or using the Editora Kai Yuen de Macau website."))}}</p></li>
                        <li><p>{{ lang($t("Editora Kai Yuen de Macau strives to provide and maintain the accuracy and the completeness of the contents of the Editora Kai Yuen de Macau website. It, however, does not assume responsibility for any mistakes or omission, and shall not be held liable for loss and damage in this regard.")) }}</p></li>
                        <li><p>{{ lang($t("Except for the contents that have been expressly stated to be produced by Editora Kai Yuen de Macau, any other contents, including but not limited to the links contained in the Editora Kai Yuen de Macau website, are not within Editora Kai Yuen de Macau's scope of liability, and therefore Editora Kai Yuen de Macau is not liable to loss and damages arising from or in connection with accidents (such as infection by computer virus), defamation, infringement of copyrights or intellectual property rights.")) }}</p></li>
                        <li><p>{{ lang($t("For the avoidance of doubts, any material downloaded or otherwise obtained through the use of the services provided by Editora Kai Yuen de Macau is done at your own risk and discretion and that you will be solely responsible for any damage to your computer system or damage or loss of data resulting from the download of any information.")) }}</p></li>
                        <li><p>{{ lang($t("You expressly acknowledge and agree that Editora Kai Yuen de Macau shall not be liable for any direct, indirect, incidental, special, consequential or exemplary or punitive damages, including but not limited to, damages for loss or profits, goodwill, use, data or other intangible losses (notwithstanding Editora Kai Yuen de Macau may have been informed of such possibility) , resulting from:")) }}<br>
                            a. {{ lang($t("the use or inability to use the service of Editora Kai Yuen de Macau, data, information, services or messages received or downloaded directly from or via Editora Kai Yuen de Macau;")) }}<br>
                            b. {{ lang($t("unauthorized access to or alteration of your transmissions or data; ")) }}<br>
                            c. {{ lang($t("any other matter relating to the service of Editora Kai Yuen de Macau.")) }}</p></li>
                        <li><p>{{ lang($t("All materials downloaded or otherwise obtained through use of the service is accessed at user's own discretion and risk, and user will be solely liable for any damage to user's computer system or loss of data that results from the download of any such material.")) }}</p></li>
                        <li><p>{{ lang($t("Editora Kai Yuen de Macau reserves the right to amend these Terms without any prior notice.")) }}</p></li>
                    </ul>
                </div>

            </div>
        </div>
    </div>

</template>

<script>

    import axios from 'axios';
    import {common} from '@mixins/common';
    import {storeMapper} from '@mixins/storeMapper';
    import api from '@js/api';
    import EventBus from '@common/eventBus';

    export default {
        name: "Disclaimer",
        mixins:[common, storeMapper],
        /**路由相處理
         * 第一次進入本頁面時的動作。
         * @param to
         * @param from
         * @param next
         */
        beforeRouteEnter (to, from, next) {

            //Note in this route guard, access 'this' using vm (e.g. vm.fetchData() will trigger this.fetchData()
            next(vm=> {

                EventBus.$emit("showGlobalLoading");
                Promise.all(
                    [
                        api.getMainCate(),
                    ]
                    //With catch(() => undefined, we'll continue to the immediate "then block" even one/some of the api call(s) is/are rejected
                    //If something has to be processed when error returns, place the logic in catch block instead
                        .map(p => p.catch(() => undefined)))
                    .then(axios.spread((responseMainCate, responseDownloadData) => {

                        if (responseMainCate) {
                            vm.setWebSiteAndCate( responseMainCate.data, vm);
                        }

                        EventBus.$emit("hideGlobalLoading");

                    }))
                /*.catch(error=>{
                       //Handle errors here if something is expected to precess here
                   });
                   */


            });
        }
    }
</script>

<style scoped>
    .title-head{margin-top: 0;}
    .terms-para{padding-bottom:2rem;}
    .terms-para:last-child{padding-bottom:0;}
    .terms-para * {line-height:170%;}
    .terms-para ul{padding-left:1rem;}
    .terms-para ul li{list-style:decimal;padding:0 0 1rem .5rem;}
    .terms-para ul li:last-child{padding-bottom:0;}
    .terms-para>p{padding-bottom:1rem;}
    .terms-para>p:last-child{padding-bottom:0;}
    h4.terms-title{font-size:1rem;padding-bottom:1rem;color:#608197;}

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Disclaimer.vue